export class RefundPaymentModel {
  public paymentId: Number;
  public reason: String;
  public montoADevolver: Number;

  constructor(_paymentId: Number, _reason: String, _montoADevolver: Number) {
    this.paymentId = _paymentId;
    this.reason = _reason;
    this.montoADevolver = _montoADevolver;
  }

  getPaymentId() {
    return this.paymentId;
  }

  setPaymentId(_paymentId: Number) {
    this.paymentId = _paymentId;
  }

  getReason() {
    return this.reason;
  }

  setReason(_reason: String) {
    this.reason = _reason;
  }
}
